import React from 'react';
import { graphql } from 'gatsby';
import Layout from '../components/Layout';
import Seo from '../components/Seo';
import Main from '../components/Main';
import Container from '../components/Container';
import PageArticle from '../components/PageArticle';

function Technologies({ data }) {
  const {
    pageTitle,
    intro,
    quote,
    metaDescription,
  } = data.allMarkdownRemark.edges[0].node.frontmatter;
  const { rawMarkdownBody, fields } = data.allMarkdownRemark.edges[0].node;
  return (
    <Layout>
      <Main>
        <>
          <Seo
            title={pageTitle}
            description={metaDescription}
            slug={fields.slug}
          />
          <Container>
            <PageArticle
              title={pageTitle}
              intro={intro}
              quote={quote}
              body={rawMarkdownBody}
              icon="facebook"
            />
          </Container>
        </>
      </Main>
    </Layout>
  );
}

export default Technologies;

export const query = graphql`
  query {
    allMarkdownRemark(
      filter: { frontmatter: { templateKey: { eq: "technologies" } } }
    ) {
      edges {
        node {
          frontmatter {
            pageTitle
            metaDescription
            intro
            quote
            layoutImage {
              childImageSharp {
                fluid(maxWidth: 880, quality: 100) {
                  ...GatsbyImageSharpFluid_withWebp
                }
              }
            }
          }
          rawMarkdownBody
          fields {
            slug
          }
        }
      }
    }
  }
`;
